import { useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";

function ScoreIframe() {
  const [searchParams] = useSearchParams();
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const eventID = searchParams.get("event_id") || searchParams.get("eventId") || "";
  const sportID = searchParams.get("sport_id") || searchParams.get("eventType") || "";
  const iframeSrc = `https://recklinesports.d247api.com/sr.php?sportid=${sportID}&eventid=${eventID}&muted`;

  return (
    <div className="relative w-full bg-[#141435]" style={{ height: "500px" }}>
      {/* Loading screen */}
      {loading && (
        <div className="absolute inset-0 flex justify-center items-center bg-[#141435] z-10">
          <span className="text-white" style={{ marginTop: -300 }}>Loading Score...</span>
        </div>
      )}

      {/* Iframe */}
      <iframe
        ref={iframeRef}
        className="w-full h-full"
        src={iframeSrc}
        style={{ transition: "height 0.3s ease", backgroundColor: "#141435" }}
        onLoad={() => setLoading(false)}
        loading="lazy"
      />

      {/* Transparent Overlay */}
      {/* <div
        className="absolute inset-0 z-20 pointer-events-none"
        style={{ backgroundColor: "transparent" }}
      >
        <img
          src="/your-image.png" // replace with your image path
          alt="Overlay Logo"
          className="absolute top-2 left-2 w-16 h-16"
          style={{ pointerEvents: "auto" }} // Allows clicking on the image
        />
      </div> */}
    </div>
  );
}

export default ScoreIframe;
